import { createRouter, createWebHistory } from 'vue-router'

export function setUpRouter(app) {
  const router = createRouter({
    history: createWebHistory(),
    routes: [
      // This path silences vue-router warnings about non-existent paths since we rarely use this library
      { path: '/:pathMatch(.*)', component: { template: `<span style="display: none;"></span>` } },
    ],
  })
  app.use(router)
}
